export default "__VITE_ASSET__C$k0HZ8A__"